(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function () {
    var el = document.querySelector('.product-recommendations');
    if (!el) return;
    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var next = doc.querySelector('.product-recommendations');
          if (next && next.innerHTML.trim().length) el.innerHTML = next.innerHTML;
        })
        .catch(function () {});
    }, { rootMargin: '0px 0px 200px 0px' });
    observer.observe(el);
  })();

  } catch(e) { console.error(e); }
})();
})();
